export const createUid = () => {
    return Math.random().toString(36).substr(2, 9);
};

export default function fileEntity(data) {
    return {
        uid: data.uid,
        name: data.name,
        originalName: data.originalName,
        size: data.size,
        mime: data.mime,
        duration: data.duration,
        extension: data.extension,
        source: data.source,
    }
};